import React, { useState } from "react";
import { sendEmail } from "utils/api";

export default function SendEmailPage() {
  const [email, setEmail] = useState("");
  return (
    <div>
      Geben Sie Ihre Email Adresse:
      <input type="text" onChange={e => setEmail(e.target.value)} />
      <button type="button" onClick={() => sendEmail(email)}>
        Test-Email senden
      </button>
    </div>
  );
}
